import { render, staticRenderFns } from "./DoKoDialogStatistics.vue?vue&type=template&id=6d4bfc52&scoped=true&"
import script from "./DoKoDialogStatistics.vue?vue&type=script&lang=ts&"
export * from "./DoKoDialogStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDialogStatistics.vue?vue&type=style&index=0&id=6d4bfc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4bfc52",
  null
  
)

export default component.exports